import React from 'react';
import { Helmet } from 'react-helmet-async';

const PageTitle = ({ name }) => {
  return (
    <Helmet>
      <title>{name} - Admin Panel | Corona Ergo</title>
    </Helmet>
  );
};
export default PageTitle;
